import bannerQueries from '@apis/queries/bannerQueries';
import { useQuery } from '@tanstack/react-query';

function useMainBanners() {
    const { data } = useQuery(bannerQueries.list('MAIN_1'));
    return data?.banners;
}

export default useMainBanners;
